/** Highest audience or scenario floor the pipeline can meet (the server caps it too). */
export const MAX_PLANNING_KNOB = 10;

/**
 * Read a typed floor from a number input. `max` on the input is only a hint:
 * typing 50 used to be accepted and saved, and was then silently unmet.
 */
export const clampPlanningKnob = (raw: string): number => {
  const value = parseInt(raw, 10);
  if (Number.isNaN(value)) return 1;
  return Math.min(MAX_PLANNING_KNOB, Math.max(1, value));
};
